import React, { memo } from 'react';
import { Check, Heart, Users, Target, Sparkles, ArrowRight } from 'lucide-react';
const OfferingsPage = () => {
  return <div className="bg-cream" data-id="element-448">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-brown to-brown-dark py-20 md:py-28" data-id="element-449">
        <div className="container mx-auto px-4 text-center" data-id="element-450">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-451">
            You Don't Have to Do This Alone
          </h1>
          <p className="text-xl md:text-2xl text-cream mb-4 max-w-3xl mx-auto" data-id="element-452">
            From pregnancy to motherhood and beyond — we're here to support,
            guide, and empower you every step of the way.
          </p>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-453">
            Whether you're expecting, nursing, or navigating life as a
            stay-at-home mom, you deserve a community that sees you, supports
            you, and helps you thrive.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-454">
            <a href="#jemi-moms-community" className="bg-white text-brown px-8 py-4 rounded-full hover:bg-cream transition-colors duration-300 text-center font-semibold" data-id="element-455">
              Join Jemi Moms Community
            </a>
            <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-brown transition-colors duration-300 text-center font-semibold" data-id="element-456">
              Explore Accountability Program
            </a>
          </div>
        </div>
      </section>

      {/* Who This Is For Section */}
      <section className="py-16 bg-white" data-id="element-457">
        <div className="container mx-auto px-4" data-id="element-458">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4 text-center" data-id="element-459">
            This Is For You If...
          </h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-460">
            You're looking for support, clarity, and community during one of
            life's most transformative seasons.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-461">
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-462">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-463">
                <Heart className="text-brown" size={32} data-id="element-464" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-465">
                You're Pregnant
              </h3>
              <p className="text-gray-700" data-id="element-466">
                And you want guidance, reassurance, and a community of women who
                understand what you're going through.
              </p>
            </div>
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-467">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-468">
                <Users className="text-brown" size={32} data-id="element-469" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-470">
                You're a Nursing Mom
              </h3>
              <p className="text-gray-700" data-id="element-471">
                Navigating the beautiful chaos of caring for your baby in their
                first year, and you need practical support and emotional
                encouragement.
              </p>
            </div>
            <div className="bg-beige p-8 rounded-lg text-center" data-id="element-472">
              <div className="w-20 h-20 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-473">
                <Target className="text-brown" size={32} data-id="element-474" />
              </div>
              <h3 className="text-xl font-bold text-brown mb-3" data-id="element-475">
                You're a Stay-at-Home Mom
              </h3>
              <p className="text-gray-700" data-id="element-476">
                Feeling stuck, lost, or unsure of your next steps — and you're
                ready to rediscover yourself and rebuild your confidence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Jemi Moms Community Section */}
      <section id="jemi-moms-community" className="py-20 bg-cream" data-id="element-477">
        <div className="container mx-auto px-4" data-id="element-478">
          <div className="max-w-4xl mx-auto" data-id="element-479">
            <div className="text-center mb-12" data-id="element-480">
              <span className="inline-block bg-brown/10 text-brown px-4 py-2 rounded-full font-medium mb-4" data-id="element-481">
                For Pregnant Women & Nursing Moms
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-482">
                Jemi Moms Community
              </h2>
              <p className="text-xl text-gray-700" data-id="element-483">
                A safe, supportive space where you're never alone on your
                motherhood journey.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-8" data-id="element-484">
              <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-485">
                What You'll Experience:
              </h3>

              <div className="space-y-6 mb-8" data-id="element-486">
                <div className="flex items-start gap-4" data-id="element-487">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-488">
                    <Check className="text-brown" size={18} data-id="element-489" />
                  </div>
                  <div data-id="element-490">
                    <h4 className="font-bold text-brown mb-2" data-id="element-491">
                      A Community That Gets It
                    </h4>
                    <p className="text-gray-700" data-id="element-492">
                      Connect with other moms who understand the sleepless
                      nights, the feeding struggles, the overwhelming joy, and
                      the quiet fears. You're not alone anymore.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-493">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-494">
                    <Check className="text-brown" size={18} data-id="element-495" />
                  </div>
                  <div data-id="element-496">
                    <h4 className="font-bold text-brown mb-2" data-id="element-497">
                      Practical Resources & Guides
                    </h4>
                    <p className="text-gray-700" data-id="element-498">
                      Get expert-backed information on pregnancy care,
                      nutrition, postpartum recovery, and baby care from 0-12
                      months. No more endless Google searches or conflicting
                      advice.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-499">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-500">
                    <Check className="text-brown" size={18} data-id="element-501" />
                  </div>
                  <div data-id="element-502">
                    <h4 className="font-bold text-brown mb-2" data-id="element-503">
                      Regular Check-In Calls
                    </h4>
                    <p className="text-gray-700" data-id="element-504">
                      Receive emotional and mental support through regular group
                      calls where you can share, ask questions, and feel truly
                      heard.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-505">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-506">
                    <Check className="text-brown" size={18} data-id="element-507" />
                  </div>
                  <div data-id="element-508">
                    <h4 className="font-bold text-brown mb-2" data-id="element-509">
                      Trusted Recommendations
                    </h4>
                    <p className="text-gray-700" data-id="element-510">
                      Access vetted product recommendations for baby care,
                      service recommendations for antenatal care, postpartum
                      support, and baby services you can trust.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-511">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-512">
                    <Check className="text-brown" size={18} data-id="element-513" />
                  </div>
                  <div data-id="element-514">
                    <h4 className="font-bold text-brown mb-2" data-id="element-515">
                      Interactive Platforms
                    </h4>
                    <p className="text-gray-700" data-id="element-516">
                      Join WhatsApp groups, online forums, and live sessions
                      where you can connect, share experiences, and build
                      lasting friendships with other moms.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-517">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-518">
                    <Check className="text-brown" size={18} data-id="element-519" />
                  </div>
                  <div data-id="element-520">
                    <h4 className="font-bold text-brown mb-2" data-id="element-521">
                      Help Planning Special Moments
                    </h4>
                    <p className="text-gray-700" data-id="element-522">
                      Get support and ideas for your baby shower, postpartum
                      retreat, and your baby's first birthday celebration. Make
                      these moments memorable and stress-free.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-523">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-524">
                    <Check className="text-brown" size={18} data-id="element-525" />
                  </div>
                  <div data-id="element-526">
                    <h4 className="font-bold text-brown mb-2" data-id="element-527">
                      Back-to-Work Accountability
                    </h4>
                    <p className="text-gray-700" data-id="element-528">
                      For pregnant and nursing moms planning to return to work,
                      get recommendations for remote work opportunities, study
                      programs, and career growth paths that fit your new life.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-beige p-6 rounded-lg mb-8" data-id="element-529">
                <h4 className="font-bold text-brown mb-3 text-lg" data-id="element-530">
                  What This Means for You:
                </h4>
                <p className="text-gray-700 mb-4" data-id="element-531">
                  You'll feel seen, supported, informed, and confident. You'll
                  have answers when you need them, encouragement when you're
                  tired, and a community that celebrates every milestone with
                  you.
                </p>
                <p className="text-gray-700 font-medium" data-id="element-532">
                  Because motherhood is hard enough — you shouldn't have to
                  figure it out alone.
                </p>
              </div>

              <div className="text-center" data-id="element-533">
                <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brown text-cream px-8 py-4 rounded-full hover:bg-brown-dark transition-colors duration-300 font-semibold text-lg" data-id="element-534">
                  Join Jemi Moms Community
                  <ArrowRight size={20} data-id="element-535" />
                </a>
                <p className="text-sm text-gray-600 mt-4" data-id="element-536">
                  Payment processed securely via Selar
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accountability Program Section */}
      <section id="accountability-program" className="py-20 bg-white" data-id="element-537">
        <div className="container mx-auto px-4" data-id="element-538">
          <div className="max-w-4xl mx-auto" data-id="element-539">
            <div className="text-center mb-12" data-id="element-540">
              <span className="inline-block bg-brown/10 text-brown px-4 py-2 rounded-full font-medium mb-4" data-id="element-541">
                For Stay-at-Home Moms
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-542">
                Accountability Program for Stay-at-Home Moms
              </h2>
              <p className="text-xl text-gray-700" data-id="element-543">
                Rediscover yourself. Rebuild your confidence. Take practical
                steps toward the life you want.
              </p>
            </div>

            <div className="bg-cream rounded-2xl shadow-lg p-8 md:p-12 mb-8" data-id="element-544">
              <div className="mb-8" data-id="element-545">
                <p className="text-lg text-gray-700 mb-4" data-id="element-546">
                  Being a stay-at-home mom is one of the most important roles in
                  the world — but it can also feel isolating, exhausting, and
                  sometimes... invisible.
                </p>
                <p className="text-lg text-gray-700 mb-4" data-id="element-547">
                  Maybe you've put your dreams on hold. Maybe you feel stuck,
                  unsure of who you are outside of being "mom." Maybe you're
                  wondering if it's too late to pursue your goals, grow your
                  career, or start something new.
                </p>
                <p className="text-lg text-gray-700 font-medium" data-id="element-548">
                  It's not too late. And you're not alone.
                </p>
              </div>

              <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-549">
                What This Program Offers:
              </h3>

              <div className="space-y-6 mb-8" data-id="element-550">
                <div className="flex items-start gap-4" data-id="element-551">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-552">
                    <Sparkles className="text-brown" size={18} data-id="element-553" />
                  </div>
                  <div data-id="element-554">
                    <h4 className="font-bold text-brown mb-2" data-id="element-555">
                      One-on-One Clarity Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-556">
                      Get personalized guidance to help you identify your
                      strengths, clarify your goals, and create a roadmap for
                      your next chapter.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-557">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-558">
                    <Sparkles className="text-brown" size={18} data-id="element-559" />
                  </div>
                  <div data-id="element-560">
                    <h4 className="font-bold text-brown mb-2" data-id="element-561">
                      Group Accountability Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-562">
                      Join other stay-at-home moms who are also on a journey of
                      growth. Share wins, challenges, and encouragement in a
                      safe, judgment-free space.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-563">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-564">
                    <Sparkles className="text-brown" size={18} data-id="element-565" />
                  </div>
                  <div data-id="element-566">
                    <h4 className="font-bold text-brown mb-2" data-id="element-567">
                      Skill-Building & Training Sessions
                    </h4>
                    <p className="text-gray-700" data-id="element-568">
                      Learn practical skills that can help you earn income,
                      pursue a passion, or prepare for a career transition — all
                      while managing your responsibilities at home.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-569">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-570">
                    <Sparkles className="text-brown" size={18} data-id="element-571" />
                  </div>
                  <div data-id="element-572">
                    <h4 className="font-bold text-brown mb-2" data-id="element-573">
                      Remote Job & Study Recommendations
                    </h4>
                    <p className="text-gray-700" data-id="element-574">
                      Get curated opportunities for remote work, online courses,
                      certifications, and career paths that fit your lifestyle
                      and goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-575">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-576">
                    <Sparkles className="text-brown" size={18} data-id="element-577" />
                  </div>
                  <div data-id="element-578">
                    <h4 className="font-bold text-brown mb-2" data-id="element-579">
                      Emotional & Mindset Support
                    </h4>
                    <p className="text-gray-700" data-id="element-580">
                      Work through limiting beliefs, rebuild your confidence,
                      and develop the mindset you need to pursue your dreams
                      without guilt or fear.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-581">
                  <div className="flex-shrink-0 w-8 h-8 bg-brown/10 rounded-full flex items-center justify-center mt-1" data-id="element-582">
                    <Sparkles className="text-brown" size={18} data-id="element-583" />
                  </div>
                  <div data-id="element-584">
                    <h4 className="font-bold text-brown mb-2" data-id="element-585">
                      Revive Your Dormant Dreams
                    </h4>
                    <p className="text-gray-700" data-id="element-586">
                      Whether it's starting a business, going back to school, or
                      simply finding more fulfillment in your daily life — we'll
                      help you take real, actionable steps forward.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg mb-8" data-id="element-587">
                <h4 className="font-bold text-brown mb-3 text-lg" data-id="element-588">
                  What This Means for You:
                </h4>
                <p className="text-gray-700 mb-4" data-id="element-589">
                  You'll gain clarity on who you are and what you want. You'll
                  rebuild your confidence and take practical steps toward
                  personal, career, or business growth. You'll feel empowered,
                  supported, and excited about your future again.
                </p>
                <p className="text-gray-700 font-medium" data-id="element-590">
                  Because being a mom doesn't mean you have to lose yourself.
                  You can thrive in both.
                </p>
              </div>

              {/* Pricing Section */}
              <div className="bg-brown/5 border-2 border-brown/20 p-8 rounded-lg mb-8" data-id="element-591">
                <h4 className="text-2xl font-bold text-brown mb-4 text-center" data-id="element-592">
                  Investment & Commitment
                </h4>
                <div className="text-center mb-6" data-id="element-593">
                  <p className="text-2xl text-gray-500 line-through mb-1" data-id="element-594">
                    ₦500,000
                  </p>
                  <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-medium mb-2" data-id="element-595">
                    🎉 Limited Time Discount!
                  </div>
                  <p className="text-4xl font-bold text-brown mb-2" data-id="element-596">₦350,000</p>
                  <p className="text-gray-600 text-lg" data-id="element-597">
                    for 12 months of transformation
                  </p>
                  <p className="text-sm text-green-600 mt-2 font-medium" data-id="element-598">
                    Save ₦150,000 — Discount available on our Selar page
                  </p>
                </div>
                <div className="space-y-3 mb-6" data-id="element-599">
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-600">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-601" />
                    <span data-id="element-602">Personalized one-on-one clarity sessions</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-603">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-604" />
                    <span data-id="element-605">Weekly group accountability and support</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-606">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-607" />
                    <span data-id="element-608">Skill-building workshops and training</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-609">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-610" />
                    <span data-id="element-611">Career and remote work guidance</span>
                  </p>
                  <p className="text-gray-700 flex items-center gap-2" data-id="element-612">
                    <Check className="text-brown flex-shrink-0" size={20} data-id="element-613" />
                    <span data-id="element-614">Ongoing emotional and mindset support</span>
                  </p>
                </div>
                <p className="text-gray-700 text-center font-medium" data-id="element-615">
                  This is more than a program — it's an investment in yourself,
                  your future, and the life you deserve to live.
                </p>
              </div>

              <div className="text-center" data-id="element-616">
                <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brown text-cream px-8 py-4 rounded-full hover:bg-brown-dark transition-colors duration-300 font-semibold text-lg" data-id="element-617">
                  Apply for Accountability Program
                  <ArrowRight size={20} data-id="element-618" />
                </a>
                <p className="text-sm text-gray-600 mt-4" data-id="element-619">
                  Payment processed securely via Selar
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="py-20 bg-beige" data-id="element-620">
        <div className="container mx-auto px-4" data-id="element-621">
          <div className="max-w-4xl mx-auto text-center" data-id="element-622">
            <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-623">
              The Transformation You Deserve
            </h2>
            <p className="text-xl text-gray-700 mb-12" data-id="element-624">
              Whether you join our community or our accountability program,
              here's what you can expect:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-625">
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-626">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-627">
                  Emotional Relief
                </h3>
                <p className="text-gray-700" data-id="element-628">
                  No more feeling alone, overwhelmed, or unsure. You'll have a
                  community and support system that truly understands.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-629">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-630">
                  Confidence
                </h3>
                <p className="text-gray-700" data-id="element-631">
                  You'll feel empowered to make decisions, pursue your goals,
                  and trust yourself as a mother and as a woman.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-632">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-633">Direction</h3>
                <p className="text-gray-700" data-id="element-634">
                  Clear, practical steps forward — whether it's caring for your
                  baby, planning your next career move, or rediscovering your
                  purpose.
                </p>
              </div>
              <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-635">
                <h3 className="text-xl font-bold text-brown mb-3" data-id="element-636">Growth</h3>
                <p className="text-gray-700" data-id="element-637">
                  Personal, professional, and emotional growth that helps you
                  become the best version of yourself — for you and your family.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-brown text-white" data-id="element-638">
        <div className="container mx-auto px-4 text-center" data-id="element-639">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-640">
            Ready to Take the Next Step?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" data-id="element-641">
            You don't have to navigate motherhood alone. Join a community that
            sees you, supports you, and helps you thrive.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-642">
            <a href="https://selar.com/50131b4y7a" target="_blank" rel="noopener noreferrer" className="bg-white text-brown px-8 py-4 rounded-full hover:bg-cream transition-colors duration-300 font-semibold" data-id="element-643">
              Join Jemi Moms Community
            </a>
            <a href="https://selar.com/theceomom" target="_blank" rel="noopener noreferrer" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-brown transition-colors duration-300 font-semibold" data-id="element-644">
              Apply for Accountability Program
            </a>
          </div>
          <p className="mt-8 text-cream/90" data-id="element-645">
            Because raising a child — and raising yourself — takes more than
            love. It takes a community. 💕
          </p>
        </div>
      </section>
    </div>;
};
export default OfferingsPage;